var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search flex"},[_c('el-input',{staticClass:"search-input",attrs:{"placeholder":_vm.placeholder},model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}}),_c('div',{staticClass:"search-btn cursor",on:{"click":function($event){return _vm.searchBtnClick()}}},[_vm._v("搜索")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }